// extracted by mini-css-extract-plugin
export default {"linkButton":"LeftNavigation_linkButton__0hXNZ"};